module.exports = __webpack_public_path__ + "img/SN.e770a0de.svg";